export default {
  account: {
    Bank: '开户行',
    CardNo: '银行卡号',
    AccountName: '开户名称',
    Balance: '余额',
    AddAccount: '新增账户',
    EditAccount: '修改账户信息',
    BankNameCanNotBeEmpty: '开户行名称不能为空',
    AccountNameCanNotBeEmpty: '开户名称不能为空',
    CardNoCanNotBeEmpty: '银行卡号不能为空',
    BalanceCanNotBeEmpty: '余额不能为空',
    PleaseEnterCorrectCardNo: '请输入正确的银行卡号',
    PleaseEnterCorrectBalance: '请输入正确的余额'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/ims/account.js